import { render, staticRenderFns } from "./UpgradeToNextPlanPopUp.vue?vue&type=template&id=39e1c7fe&"
import script from "./UpgradeToNextPlanPopUp.vue?vue&type=script&lang=js&"
export * from "./UpgradeToNextPlanPopUp.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports